<template>
<!-- component is a multi template
check for other variants -->

    <section id="account-data">
        <div class="list-group-item collapse-element d-flex justify-content-between align-items-center">
            <b>{{$t('co.address_data.variable-title', { steps: getSteps })}}</b>
            <b-button variant="text" v-if="!isVisible" @click="openCollapse">
                <font-awesome-icon icon="far fa-pencil" />
            </b-button>
        </div>
        <b-collapse
            class="list-group-item checkout-payment-box "
            tag="div"
            v-model="isVisible"
        >

            <div class="row">
                <div class="col-12 my-3"><p><b>{{$t('co.address_data.delivery_address')}}</b></p></div>
                <div class="col-12 col-md-6 my-3">
                    <b-form-group :label="$t('co.address_data.street')" label-for="street">
                        <b-form-input
                            id="street"
                            :placeholder="$t('co.address_data.street')"
                            type="text"
                            v-model="address.delivery.street.value"
                            :state="address.delivery.street.state"
                            aria-describedby="delivery-street-error"
                        ></b-form-input>
                        <b-form-invalid-feedback id="delivery-street-error">{{$t('co.error.required_field')}}</b-form-invalid-feedback>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6 my-3">
                    <b-form-group
                        :label="$t('co.address_data.number')"
                        label-for="number"
                    >
                        <b-form-input
                            id="number"
                            :placeholder="$t('co.address_data.number.placeholder')"
                            type="text"
                            v-model="address.delivery.number.value"
                            :state="address.delivery.number.state"
                            aria-describedby="delivery-number-error"
                        ></b-form-input>
                        <b-form-invalid-feedback id="delivery-number-error">{{$t('co.error.required_field')}}</b-form-invalid-feedback>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6 my-3">
                    <b-form-group
                        :label="$t('co.address_data.post_code')"
                        label-for="code"
                    >
                        <b-form-input
                            id="code"
                            :placeholder="$t('co.address_data.post_code.placeholder')"
                            type="text"
                            v-model="address.delivery.code.value"
                            :state="address.delivery.code.state"
                            aria-describedby="delivery-code-error"
                        ></b-form-input>
                        <b-form-invalid-feedback id="delivery-code-error">
                            <span v-if="!address.delivery.code.value.length">{{$t('co.error.required_field')}}<br></span>
                            <span v-if="!address.delivery.code.valid">{{$t('co.error.numeric.only')}}</span>
                        </b-form-invalid-feedback>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6 my-3">
                    <b-form-group
                        :label="$t('co.address_data.location')"
                        label-for="location"
                    >
                        <b-form-input
                            id="location"
                            :placeholder="$t('co.address_data.location')"
                            type="text"
                            v-model="address.delivery.location.value"
                            :state="address.delivery.location.state"
                            aria-describedby="delivery-location-error"
                        ></b-form-input>
                        <b-form-invalid-feedback id="delivery-location-error">{{$t('co.error.required_field')}}</b-form-invalid-feedback>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6 my-3">
                    <b-form-group
                        :label="$t('co.address_data.country')"
                        label-for="country"
                    >
                        <b-form-select
                            id="country"
                            v-model="address.delivery.country.value"
                            :state="address.delivery.country.state"
                            aria-describedby="delivery-country-error"
                        >
                            <b-form-select-option
                                v-for="option in address.delivery.country.options"
                                :value="option.value"
                                :key="option.value"
                            >
                                {{ $t(`countries.${option.text}`) }}
                            </b-form-select-option>
                        </b-form-select>
                        <b-form-invalid-feedback id="delivery-country-error">{{$t('co.error.required_field')}}</b-form-invalid-feedback>
                    </b-form-group>
                </div>
            </div>

            <section  v-if="!isB2b">
                <div class="row">
                    <div class="col-12">
                        <b-form-checkbox v-model="hasOwnDeliveryAddress">{{$t('co.address_data.different_payment_address')}}</b-form-checkbox>
                    </div>
                </div>
            </section>

            <div class="row" v-if="hasOwnDeliveryAddress && !isB2b">
                <div class="col-12 col-md-6 my-3">
                    <b-form-group :label="$t('co.address_data.street')" label-for="street-payment">
                        <b-form-input
                            id="street-payment"
                            :placeholder="$t('co.address_data.street')"
                            type="text"
                            v-model="address.payment.street.value"
                            :state="address.payment.street.state"
                            aria-describedby="payment-street-error"
                        ></b-form-input>
                        <b-form-invalid-feedback id="payment-street-error">{{$t('co.error.required_field')}}</b-form-invalid-feedback>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6 my-3">
                    <b-form-group
                        :label="$t('co.address_data.number')"
                        label-for="number-payment"
                    >
                        <b-form-input
                            id="number-payment"
                            :placeholder="$t('co.address_data.number.placeholder')"
                            type="text"
                            v-model="address.payment.number.value"
                            :state="address.payment.number.state"
                            aria-describedby="payment-number-error"
                        ></b-form-input>
                        <b-form-invalid-feedback id="payment-number-error">{{$t('co.error.required_field')}}</b-form-invalid-feedback>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6 my-3">
                    <b-form-group
                        :label="$t('co.address_data.post_code')"
                        label-for="code-payment"
                    >
                        <b-form-input
                            id="code-payment"
                            :placeholder="$t('co.address_data.post_code.placeholder')"
                            type="text"
                            v-model="address.payment.code.value"
                            :state="address.payment.code.state"
                            aria-describedby="payment-code-error"
                        ></b-form-input>
                        <b-form-invalid-feedback id="payment-code-error">
                            <span v-if="!address.payment.code.value.length">{{$t('co.error.required_field')}}<br></span>
                            <span v-if="!address.payment.code.valid">{{$t('co.error.numeric.only')}}</span>
                        </b-form-invalid-feedback>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6 my-3">
                    <b-form-group
                        :label="$t('co.address_data.location')"
                        label-for="location-payment"
                    >
                        <b-form-input
                            id="location-payment"
                            :placeholder="$t('co.address_data.location')"
                            type="text"
                            v-model="address.payment.location.value"
                            :state="address.payment.location.state"
                            aria-describedby="payment-location-error"
                        ></b-form-input>
                        <b-form-invalid-feedback id="payment-location-error">{{$t('co.error.required_field')}}</b-form-invalid-feedback>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6 my-3">
                    <b-form-group
                        :label="$t('co.address_data.country')"
                        label-for="country-payment"
                    >
                        <b-form-select
                            id="country-payment"
                            v-model="address.payment.country.value"
                            :state="address.payment.country.state"
                            aria-describedby="payment-country-error"
                        >
                            <b-form-select-option
                                v-for="option in address.payment.country.options"
                                :value="option.value"
                                :key="option.value"
                            >
                                {{ $t(`countries.${option.text}`) }}
                            </b-form-select-option>
                        </b-form-select>
                        <b-form-invalid-feedback id="payment-country-error">{{$t('co.error.required_field')}}</b-form-invalid-feedback>
                    </b-form-group>
                </div>
            </div>
            <div class="row" v-if="addressError">
                <div class="col-12">
                    <div class="is-invalid"></div>
                    <div class="invalid-feedback">{{$t('co.address_data.delivery_address.error')}}</div>
                </div>
            </div>

            <div class="row d-flex justify-content-end mt-3">
                <div class="col-12 d-flex justify-content-end">
                    <button type="button" class="btn btn-primary btn-mobile-full-width" @click="submit" v-if="!isSubmitting">{{$t('co.button.continue')}}</button>
                    <button type="button" class="btn btn-primary btn-mobile-full-width disabled" v-else>{{$t('co.button.loading')}}</button>
                </div>
            </div>
        </b-collapse>
    </section>
<!-- component is a multi template
check for other variants -->
</template>

<script>
import { BCollapse, BFormCheckbox, BFormGroup, BFormInput, BFormInvalidFeedback, BFormSelect, BButton, BFormSelectOption } from "bootstrap-vue"
import { EventBus } from '../../event-bus'
import countries from '../../stores/countries'

export default {
    name: 'CheckoutAddressDataDefaultComponent',
    components: {
        BCollapse,
        BButton,
        BFormCheckbox, BFormGroup, BFormInput, BFormInvalidFeedback, BFormSelect, BFormSelectOption
    },
    props: {
        entry: null,
        user: null,
        numberOfSteps: {
            type: Number,
        },
    },
    data() {
        return {
            isUpdate: {
                delivery: null,
                payment: null
            },
            isVisible: false,
            isSubmitting: false,
            error: false,
            addressError: false,
            errorSum: 0,
            hasOwnDeliveryAddress: false,
            costs: null,
            addressIds: {
              delivery: null,
              payment: null
            },
            address: {
                delivery: {
                    street: {
                        value: '',
                        state: null
                    },
                    number: {
                        value: '',
                        state: null,
                    },
                    location: {
                        value: '',
                        state: null
                    },
                    code: {
                        value: '',
                        state: null,
                        valid: null
                    },
                    country: {
                        value: this.$root.whitelabel.state.contact.address.country,
                        state: null,
                        options: countries.entries
                    },
                },
                payment: {
                    street: {
                        value: '',
                        state: null
                    },
                    number: {
                        value: '',
                        state: null,
                    },
                    location: {
                        value: '',
                        state: null
                    },
                    code: {
                        value: '',
                        state: null,
                        valid: null
                    },
                    country: {
                        value: this.$root.whitelabel.state.contact.address.country,
                        state: null,
                        options: countries.entries
                    },
                }
            }
        }
    },
    methods: {
        init(){
            this.isVisible = true
            this.initFields()
        },
        initFields() {
            if(this.entry.delivery_address_uuid && this.entry.delivery_address_data){
                this.isUpdate.delivery = true
                this.addressIds.delivery = this.entry.delivery_address_uuid

                this.address.delivery.street.value = this.entry.delivery_address_data.street ? this.entry.delivery_address_data.street : ''
                this.address.delivery.number.value = this.entry.delivery_address_data.house_number ? this.entry.delivery_address_data.house_number : ''
                this.address.delivery.location.value = this.entry.delivery_address_data.city ? this.entry.delivery_address_data.city : ''
                this.address.delivery.code.value = this.entry.delivery_address_data.postal_code ? this.entry.delivery_address_data.postal_code : ''
                this.address.delivery.country.value = this.entry.delivery_address_data.country ? this.entry.delivery_address_data.country : ''
            } else {
                if(this.user && this.user.delivery_address){
                    this.isUpdate.delivery = true
                    this.addressIds.delivery = this.user.delivery_address.uuid

                    this.address.delivery.street.value = this.user.delivery_address.street ? this.user.delivery_address.street : ''
                    this.address.delivery.number.value = this.user.delivery_address.house_number ? this.user.delivery_address.house_number : ''
                    this.address.delivery.location.value = this.user.delivery_address.city ? this.user.delivery_address.city : ''
                    this.address.delivery.code.value = this.user.delivery_address.postal_code ? this.user.delivery_address.postal_code : ''
                    this.address.delivery.country.value = this.user.delivery_address.country ? this.user.delivery_address.country : ''
                }
            }

            if(this.entry.invoice_address_uuid && this.entry.invoice_address_data){
                this.hasOwnDeliveryAddress = true
                this.isUpdate.payment = true
                this.addressIds.payment = this.entry.invoice_address_uuid

                this.address.payment.street.value = this.entry.invoice_address_data.street ? this.entry.invoice_address_data.street : ''
                this.address.payment.number.value = this.entry.invoice_address_data.house_number ? this.entry.invoice_address_data.house_number : ''
                this.address.payment.location.value = this.entry.invoice_address_data.city ? this.entry.invoice_address_data.city : ''
                this.address.payment.code.value = this.entry.invoice_address_data.postal_code ? this.entry.invoice_address_data.postal_code : ''
                this.address.payment.country.value = this.entry.invoice_address_data.country ? this.entry.invoice_address_data.country : ''

                if(this.address.delivery.street.value == this.address.payment.street.value && this.address.delivery.number.value == this.address.payment.number.value && this.address.delivery.location.value == this.address.payment.location.value && this.address.delivery.code.value == this.address.payment.code.value && this.address.delivery.country.value == this.address.payment.country.value ){
                    this.hasOwnDeliveryAddress = false
                }
            } else {
                if(this.user.invoice_address_id){
                    this.isUpdate.payment = true
                    this.addressIds.payment = this.user.invoice_address.uuid

                    this.address.payment.street.value = this.user.invoice_address.street ? this.user.invoice_address.street : ''
                    this.address.payment.number.value = this.user.invoice_address.house_number ? this.user.invoice_address.house_number : ''
                    this.address.payment.location.value = this.user.invoice_address.city ? this.user.invoice_address.city : ''
                    this.address.payment.code.value = this.user.invoice_address.postal_code ? this.user.invoice_address.postal_code : ''
                    this.address.payment.country.value = this.user.invoice_address.country ? this.user.invoice_address.country : ''
                }
            }
        },
        submit(){
            this.addressError = false
            this.validateInput()

            if(this.errorSum === 0){
                /*
                nested workflow:
                1. submit / update payment address
                2. submit / update delivery address
                3. get delivery costs
                3. update subscripting
                4. go to next step
                */
                if(this.isUpdate.payment){
                    this.updatePaymentAddress()
                } else {
                    this.submitPaymentAddress()
                }
            }
        },
        validateInput(){
            this.errorSum = 0
            this.error = false

            if(this.hasOwnDeliveryAddress){
                for (let entry in this.address.payment) {
                    let state = this.address.payment[entry].value !== ''

                    if (entry === 'code') {
                        let state
                        
                        switch (this.address.payment.country.value) {
                            case 'ca':
                                state = /^[A-Z]\d[A-Z] \d[A-Z]\d$/.test(this.address.payment[entry].value)
                                break;
                            default:
                                state = /^\d+$/.test(this.address.payment[entry].value)
                                break;
                        }
                        this.address.payment[entry].valid = state;
                    }

                    this.address.payment[entry].state = state

                    if(!state){
                        this.errorSum++
                    }
                }
            }

            for (let entry in this.address.delivery) {
                let state = this.address.delivery[entry].value !== ''

                    if (entry === 'code') {
                        let state;
                        switch (this.address.delivery.country.value) {
                            case 'ca':
                                state = /^[A-Z]\d[A-Z] \d[A-Z]\d$/.test(this.address.delivery[entry].value)
                                break;
                            default:
                                state = /^\d+$/.test(this.address.delivery[entry].value)
                                break;
                        }
                        this.address.delivery[entry].valid = state
                    }

                this.address.delivery[entry].state = state

                if(!state){
                    this.errorSum++
                }
            }

            if(this.errorSum > 0){
                this.error = true
            }
        },
        submitPaymentAddress(){
            this.isSubmitting = true

            if(this.hasOwnDeliveryAddress){
                this.$axios.post('api/v1/checkout/address', {
                    user_uuid: this.$root.user.state.data.faaren_uuid,
                    street: this.address.payment.street.value,
                    house_number: this.address.payment.number.value,
                    postal_code: this.address.payment.code.value,
                    city: this.address.payment.location.value,
                    country: this.address.payment.country.value
                }).then(response => {
                    if(response.data){
                        this.addressIds.payment = response.data.uuid
                        this.submitDeliveryAddress()
                    } else {
                        this.error = true
                    }
                }).catch(error => {
                    this.isSubmitting = false
                    this.error = true
                });
            } else {
                this.$axios.post('api/v1/checkout/address', {
                    user_uuid: this.$root.user.state.data.faaren_uuid,
                    street: this.address.delivery.street.value,
                    house_number: this.address.delivery.number.value,
                    postal_code: this.address.delivery.code.value,
                    city: this.address.delivery.location.value,
                    country: this.address.delivery.country.value
                }).then(response => {
                    if(response.data){
                        this.addressIds.payment = response.data.uuid
                        this.submitDeliveryAddress()
                    } else {
                        this.error = true
                    }
                }).catch(error => {
                    this.isSubmitting = false
                    this.error = true
                });
            }
        },
        updatePaymentAddress(){
            this.isSubmitting = true
            if(this.hasOwnDeliveryAddress){
                this.$axios.put('api/v1/dashboard/update_address', {
                    uuid: this.addressIds.payment,
                    street: this.address.payment.street.value,
                    house_number: this.address.payment.number.value,
                    postal_code: this.address.payment.code.value,
                    city: this.address.payment.location.value,
                    country: this.address.payment.country.value
                }).then(response => {
                    if(response.data){
                        if(this.isUpdate.payment){
                            this.updateDeliveryAddress()
                        } else {
                            this.submitDeliveryAddress()
                        }
                    } else {
                        this.error = true
                    }
                }).catch(error => {
                    this.isSubmitting = false
                    this.error = true
                });
            } else {
                this.$axios.put('api/v1/dashboard/update_address', {
                    uuid: this.addressIds.delivery,
                    street: this.address.delivery.street.value,
                    house_number: this.address.delivery.number.value,
                    postal_code: this.address.delivery.code.value,
                    city: this.address.delivery.location.value,
                    country: this.address.delivery.country.value
                }).then(response => {
                    if(response.data){
                        if(this.isUpdate.payment){
                            this.updateDeliveryAddress()
                        } else {
                            this.submitDeliveryAddress()
                        }
                    } else {
                        this.error = true
                    }
                }).catch(error => {
                    this.isSubmitting = false
                    this.error = true
                });
            }
        },
        submitDeliveryAddress(){
            this.$axios.post('api/v1/checkout/address', {
                uuid: this.addressIds.delivery,
                street: this.address.delivery.street.value,
                house_number: this.address.delivery.number.value,
                postal_code: this.address.delivery.code.value,
                city: this.address.delivery.location.value,
                country: this.address.delivery.country.value
            }).then(response => {
                if(response.data){
                    this.addressIds.delivery = response.data.uuid
                    if (this.entry.vehicle.delivery_option !== 'no_delivery') {
                        this.updateDeliveryCosts()
                    } else {
                        this.updateSubscription()
                    }
                } else {
                    this.error = true
                }
            }).catch(error => {
                this.isSubmitting = false
                this.error = true
            });
        },
        updateDeliveryAddress(){
            this.$axios.put('api/v1/dashboard/update_address', {
                uuid: this.addressIds.delivery,
                street: this.address.delivery.street.value,
                house_number: this.address.delivery.number.value,
                postal_code: this.address.delivery.code.value,
                city: this.address.delivery.location.value,
                country: this.address.delivery.country.value
            }).then(response => {
                if(response.data){
                    if (this.entry.vehicle.delivery_option !== 'no_delivery') {
                        this.updateDeliveryCosts()
                    } else {
                        this.updateSubscription()
                    }
                } else {
                    this.error = true
                }
            }).catch(error => {
                this.isSubmitting = false
                this.error = true
            });
        },
        updateDeliveryCosts(){
            const address = `${this.address.delivery.street.value} ${this.address.delivery.number.value}, ${this.address.delivery.code.value} ${this.address.delivery.location.value}, ${this.address.delivery.country.value}`

            this.$axios.post('api/v1/vehicle/delivery_cost', {
                vehicle_uuid : this.entry.vehicle_uuid,
                address : address
            }).then(response => {
                if(!response.error){
                    this.costs = response.data
                    if(this.costs.distance.length > 0){
                        this.updateSubscription()
                    } else {
                        this.addressError = true
                        this.isSubmitting = false
                    }
                } else {
                    this.addressError = true
                    this.isSubmitting = false
                }
            }).catch(error => {
                this.isSubmitting = false
                this.error = true
            });
        },
        updateSubscription(){
            this.$axios.put('api/v1/checkout/update_subscription', {
                invoice_address_uuid  : this.addressIds.payment,
                delivery_address_uuid : this.addressIds.delivery,
                subscription_uuid: this.entry.uuid,
                delivery_cost : this.costs ? this.costs : 0,
            }).then(response => {
                if(response.data){
                    if (response.data == 'vehicle_not_available') {
                        alert(this.$t('checkout.redirect_error'))
                        this.$router.push('/')
                    }

                    this.isSubmitting = false
                    this.isVisible= false
                    EventBus.$emit('checkout-open-step-3', null)
                    EventBus.$emit('update-subscription', response.data.data)

                    document.getElementById('payment-data').scrollIntoView()
                } else {
                    this.error = true
                }
            }).catch(error => {
                this.isSubmitting = false
                this.error = true
            });
        },
        openCollapse() {
            EventBus.$emit('close-all-collapses', null)
            this.$nextTick(() => {
                this.init()
            })
        },
        closeCollapse() {
            this.isVisible = false
        }
    },
    mounted() {
        EventBus.$on('close-all-collapses', this.closeCollapse)
        EventBus.$on('checkout-open-step-2', this.init);
    },
    computed: {
        getSteps(){
            return this.numberOfSteps
        },
        isB2b() {
            return this.$root.whitelabel?.state?.settings?.is_b2b
        }
    },
    watch: {
        entry() {
            if(this.entry !== null){
                this.initFields()
            }
        }
    },
}
</script>
